module.exports = __webpack_public_path__ + "img/shotgun-shell-speed.3e924e18.png";